import { CalendarOff } from 'lucide-react';
import { DiscardChangesDialog } from '@/components/common/DiscardChangesDialog';
import {
  FormDialog,
  FormSection,
  FormStatusField,
  FormTextareaField,
  FormTextField,
} from '@/components/common/FormDialog';
import { useLeaveTypeForm } from '../hooks/useLeaveTypeForm';
import type { LeaveType } from '../types/leaveType.types';

interface LeaveTypeFormModalProps {
  leaveType: LeaveType | null;
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export function LeaveTypeFormModal({ leaveType, open, onOpenChange }: LeaveTypeFormModalProps) {
  const {
    form,
    isEditMode,
    isPending,
    submit,
    isDiscardDialogOpen,
    requestClose,
    confirmDiscard,
    cancelDiscard,
  } = useLeaveTypeForm({
    leaveType,
    open,
    onClose: () => onOpenChange(false),
  });

  function handleOpenChange(nextOpen: boolean) {
    if (!nextOpen) {
      requestClose();
      return;
    }
    onOpenChange(nextOpen);
  }

  return (
    <>
      <FormDialog
        open={open}
        onOpenChange={handleOpenChange}
        icon={CalendarOff}
        title={isEditMode ? 'Edit Leave Type' : 'Add Leave Type'}
        description="A leave type is what employees pick when they apply for leave."
        form={form}
        isPending={isPending}
        isEditMode={isEditMode}
        onSubmit={submit}
      >
        <FormSection>
          <FormTextField
            control={form.control}
            name="code"
            label="Code"
            placeholder="CASUAL"
            isUpperCase
          />
          <FormTextField
            control={form.control}
            name="name"
            label="Name"
            placeholder="Casual Leave"
          />
          <FormTextareaField
            control={form.control}
            name="description"
            label="Description"
            placeholder="Shown to employees"
            isFullRow
          />
        </FormSection>
        <FormStatusField control={form.control} name="isActive" />
      </FormDialog>

      <DiscardChangesDialog
        open={isDiscardDialogOpen}
        onOpenChange={(nextOpen) => !nextOpen && cancelDiscard()}
        onDiscard={confirmDiscard}
      />
    </>
  );
}
